"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What does 'Patient as Family' mean for my care?",
  answer: "At NeuroFamily, we treat every individual with the same compassion and respect we would offer our own loved ones. This philosophy ensures that your emotional well-being is prioritized alongside your clinical recovery throughout your neurological journey."
}, {
  question: "What are the benefits of minimally invasive neurosurgery?",
  answer: "Our state-of-the-art technology allows for smaller incisions, which typically results in significantly less post-operative pain, reduced risk of infection, and a much faster return to your daily life compared to traditional surgical methods."
}, {
  question: "Do I need a referral for a consultation?",
  answer: "While many patients are referred by their primary care physician, we also welcome direct inquiries. Our multidisciplinary team will review your history and determine the most appropriate surgical or non-surgical path for your specific condition."
}, {
  question: "What neurological conditions do you treat?",
  answer: "We specialize in a comprehensive range of disorders affecting the brain, spine, and peripheral nerves. This includes complex spinal reconstructions, brain tumor management, and chronic pain solutions using the latest medical advancements."
}, {
  question: "How long is the typical recovery period?",
  answer: "Recovery times vary based on the procedure and individual health. However, our focus on minimally invasive techniques and personalized rehabilitation plans often allows patients to recover more quickly and comfortably than with standard approaches."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="90452" id="common-questions" className="bg-background py-16 md:py-24 lg:py-32">
      <div ref={ref} className={`container mx-auto px-4 max-w-[800px] transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-sans text-foreground mb-4 tracking-tight">
            Common Questions
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
            Explore answers regarding our multidisciplinary approach, advanced surgical technology, and the NeuroFamily philosophy of care.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full border-t border-border">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="px-2 sm:px-4 hover:bg-accent/10 transition-colors duration-300 data-[state=open]:bg-accent/5 border-b border-border">
              <AccordionTrigger className="font-sans font-medium text-base md:text-xl text-foreground hover:no-underline py-6 text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-muted-foreground text-base leading-relaxed pb-8">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-16 text-center bg-accent/20 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-border/40 shadow-sm">
          <h3 className="text-xl md:text-2xl font-bold font-sans text-foreground mb-3">
            Still seeking clarity?
          </h3>
          <p className="text-muted-foreground font-sans mb-8 max-w-md mx-auto">
            Our compassionate team is ready to provide the information you need to move forward with confidence and peace of mind.
          </p>
          <Button asChild size="lg" className="font-sans font-medium rounded-full px-10 bg-primary text-primary-foreground hover:scale-[1.02] transition-transform duration-300">
            <Link to="/ConnectPage">Connect With Us</Link>
          </Button>
        </div>
      </div>
    </section>;
}